import { jsx } from "react/jsx-runtime";
import { IconArrowRight } from "../ConciergeIcons.js";
import { useState } from "react";
const SubmitButton = ({
  disabled,
  isStreaming = false,
  onStop,
  styles,
  resolveColor
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const backgroundColor = isHovered ? resolveColor(styles.submitButtonBgColorHover) : resolveColor(styles.submitButtonBgColor);
  const iconColor = resolveColor(styles.submitButtonIconColor);
  const handleClick = (e) => {
    if (isStreaming && onStop) {
      e.preventDefault();
      onStop();
    }
  };
  return /* @__PURE__ */ jsx(
    "button",
    {
      type: isStreaming ? "button" : "submit",
      disabled: !isStreaming && disabled,
      onClick: handleClick,
      "aria-label": isStreaming ? "Stop generating" : "Submit",
      "data-concierge-submit": true,
      className: "tw:flex tw:items-center tw:justify-center tw:cursor-pointer disabled:tw:opacity-50 disabled:tw:cursor-not-allowed",
      style: {
        width: styles.submitButtonSize,
        height: styles.submitButtonSize,
        backgroundColor,
        borderRadius: styles.submitButtonBorderRadius,
        border: "none",
        transition: "background-color 0.15s ease"
      },
      onMouseEnter: () => setIsHovered(true),
      onMouseLeave: () => setIsHovered(false),
      children: isStreaming ? /* @__PURE__ */ jsx(
        "div",
        {
          style: {
            width: Math.round(styles.submitButtonSize / 3),
            height: Math.round(styles.submitButtonSize / 3),
            borderRadius: 1,
            backgroundColor: "#FFFFFF"
          }
        }
      ) : /* @__PURE__ */ jsx(IconArrowRight, { size: styles.submitButtonSize / 2, style: { color: iconColor } })
    }
  );
};
export {
  SubmitButton
};
//# sourceMappingURL=SubmitButton.js.map
